import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const OAAP_BASE = `${getNodeServerUrl()}/oaap`;

/**
 * Upload a new OAAP file (multipart/form-data).
 * @param {FormData} formData - must include 'file' + body fields
 * @returns {Promise} Axios response
 */
export const uploadOaapApi = (formData) =>
  axios.post(`${OAAP_BASE}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

/**
 * Replace an existing OAAP submission.
 * @param {number} id - Existing submission id
 * @param {FormData} formData
 * @returns {Promise}
 */
export const replaceOaapApi = (id, formData) =>
  axios.put(`${OAAP_BASE}/replace/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

/**
 * List own submissions for a user.
 * @param {string} userCode
 * @param {number} [month]
 * @param {number} [year]
 * @returns {Promise}
 */
export const listOaapApi = (userCode, month, year) => {
  const params = { userCode };
  if (month) params.month = month;
  if (year) params.year = year;
  return axios.get(`${OAAP_BASE}/list`, { params });
};

/**
 * List BM submissions for ZM review, filtered by BM email addresses.
 * @param {string} bmEmails - Comma-separated BM email addresses (from Pidilite_Hierarchy__c)
 * @param {number} month
 * @param {number} year
 * @returns {Promise}
 */
export const listForZmReviewApi = (bmEmails, month, year) =>
  axios.get(`${OAAP_BASE}/list/zm-review`, {
    params: { bmEmails, month, year },
  });

/**
 * List ZM submissions for NSM review, filtered by ZM email addresses.
 * @param {string} zmEmails - Comma-separated ZM email addresses (from Pidilite_Hierarchy__c)
 * @param {number} month
 * @param {number} year
 * @returns {Promise}
 */
export const listForNsmReviewApi = (zmEmails, month, year) =>
  axios.get(`${OAAP_BASE}/list/nsm-review`, {
    params: { zmEmails, month, year },
  });
